import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled, alpha, useTheme } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../context-state/AuthContext';
// locales
import { useLocales } from '../../../locales';
// components
import Iconify from '../../../components/minimal/iconify';
import { CustomAvatar } from '../../../components/minimal/custom-avatar';
import { getUserAvatarPath } from "../../../utils/userAvatar";
import { useDashboardContext } from "../../../context-state/DashboardContext";
import { varSlide } from "../../../components/minimal/animate";
import { PATH_DASHBOARD } from "../../../routes/paths";

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1, 2),
  gap: theme.spacing(2),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.customShadows.z1,
  transition: theme.transitions.create(['background-color', 'box-shadow']),
  '&:hover': {
    backgroundColor: alpha(theme.palette.grey[500], 0.2),
    boxShadow: theme.customShadows.z8,
  },
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const theme = useTheme();
  const { user } = useAuthContext();
  const { translate } = useLocales();
  const userName = `${user?.lname} ${user?.fname}`

  const chevronIcon = theme.direction === 'rtl' ? 'eva:arrow-ios-back-fill' : 'eva:arrow-ios-forward-fill';

  const userImage = user?.imageUrl ? user?.imageUrl : getUserAvatarPath()

  return (
      <Link component={RouterLink} to={PATH_DASHBOARD.profile} underline="none" color="inherit">
        <StyledRoot>
          <CustomAvatar src={userImage} alt={userName} name={userName} />

          <Box sx={{ minWidth: 0 }}>
            <Typography sx={{ textTransform: 'capitalize' }} variant="subtitle2" noWrap>
              {user?.lname} {user?.fname}
            </Typography>

            <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
              {user?.role}
            </Typography>

            <Typography variant="caption" noWrap sx={{ display: 'block', color: 'text.secondary', fontSize: 11 }}>
              {translate('my_account_and_settings')}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto', color: 'text.secondary' }}>
            <Iconify icon="eva:settings-2-outline" width={16} />
            <Iconify icon={chevronIcon} width={14} />
          </Box>
        </StyledRoot>
      </Link>
  );
}
